import QuickBetslipControllerImpl from './quick-betslip-controller.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Quick betslip controller.
 *
 * @class QuickBetslipController
 * @memberof Mojito.Modules.QuickBetslip
 */

/**
 * QuickBetslipController prop types.
 *
 * @property {Function} [onClose = ()=>{}] - Callback on close quick betslip.
 * @memberof Mojito.Modules.QuickBetslip.QuickBetslipController
 */
const propTypes = {
    onClose: PropTypes.func,
};

export default UIControllerView('QuickBetslipController', QuickBetslipControllerImpl, propTypes);
